import { FormattedMessage } from "react-intl";

const VerificationStatus = (props: { verifiedStatus: boolean }) => {
  const { verifiedStatus } = props;
  return (
    <FormattedMessage
      tagName="span"
      id={
        verifiedStatus
          ? "settings-account-verified"
          : "settings-account-unverified"
      }
    />
  );
};

export default VerificationStatus;
